import { fetchRequest, handleErrors } from '../../../shared/src/API/baseAPI.js';
import { showAlert } from '../../../shared/src/Util/alerts.js';

function getCountryFromTarget(target) {
    if (!target) return '';
    return (target.dataset && target.dataset.country) ? target.dataset.country : '';
}

function onCountryActionClick(e) {
    const btn = e.target?.closest?.('.country-action');
    if (!btn) return;

    const action = btn.dataset.action;
    const country = getCountryFromTarget(btn);

    if (!action || !country) return;

    if (action === 'rename') {
        const next = window.prompt(t('city.countryAdmin.renamePrompt'), country);
        if (!next || !next.trim() || next.trim() === country) return;

        fetchRequest(
            'PUT',
            `/api/v1/city/country/${encodeURIComponent(country)}`,
            { country: next.trim() },
            { 'Content-Type': 'application/json' },
            null,
            (res) => {
                if (res.error) return handleErrors(res);
                showAlert(t('city.countryAdmin.renamed'), 'success');
                window.location.reload();
            },
            true
        );
        return;
    }

    if (action === 'merge') {
        const to = window.prompt(t('city.countryAdmin.mergePrompt'), country);
        if (!to || !to.trim() || to.trim().toLowerCase() === country.toLowerCase()) return;

        fetchRequest(
            'POST',
            '/api/v1/city/country/merge',
            { from: country, to: to.trim() },
            { 'Content-Type': 'application/json' },
            null,
            (res) => {
                if (res.error) return handleErrors(res);
                showAlert(t('city.countryAdmin.merged'), 'success');
                window.location.reload();
            },
            true
        );
        return;
    }

    if (action === 'delete') {
        const ok = window.confirm(t('city.countryAdmin.deleteConfirm', { country }));
        if (!ok) return;

        const mergeInto = window.prompt(
            t('city.countryAdmin.deletePrompt'),
            ''
        );

        const body = mergeInto && mergeInto.trim().length > 0
            ? { mergeInto: mergeInto.trim() }
            : null;

        fetchRequest(
            'DELETE',
            `/api/v1/city/country/${encodeURIComponent(country)}`,
            body,
            { 'Content-Type': 'application/json' },
            null,
            (res) => {
                if (res.error) return handleErrors(res);
                if (body) {
                    showAlert(t('city.countryAdmin.merged'), 'success');
                } else {
                    showAlert(t('city.countryAdmin.deleted'), 'success');
                }
                window.location.reload();
            },
            true
        );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (typeof isAdmin === 'undefined' || !isAdmin) return;
    document.addEventListener('click', onCountryActionClick);
});
